import type { IFetchReturnableOrder } from "../types/api/return";

interface IProps {
  storeName: string;
  domain?: "kr" | "intl" | "";
  orderId: string;
  customerId: string;
}

// common_get_returnable_fulfillments
// Return 페이제서 반품이 가능한 주문 정보 조회 API
export const fetchReturnableOrder = async ({
  storeName,
  domain = "",
  orderId,
  customerId,
}: IProps): Promise<IFetchReturnableOrder | undefined> => {
  const lambdaUrl = "https://unchjbztzqx7ng7ehlap4khwgy0lkbao.lambda-url.ap-northeast-2.on.aws/";

  try {
    const response = await fetch(lambdaUrl, {
      method: "POST",
      body: JSON.stringify({ orderId, storeName, domain, customerId }),
    }).then((res) => res);

    if (response.status === 200) {
      return (await response.json()) as IFetchReturnableOrder;
    }
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    throw new Error(message);
  }
};
